
import { defineComponent, h, useCssModule } from 'vue';

import config from '../home.conf.json';
import bus from 'src/bus';
import { appStoreMapper } from 'src/store/appstore';
import { homeStoreMapper } from '../store';
import i18n from '@/translate/lang';

export default defineComponent({
  name: 'HomeTabbarItem',
  render() {
    const style = useCssModule();

    return h('f7-link', {
      class: [
        style.link,
        {
          ['tab-link-' + config.tabName]: true,
        },
      ],
      props: {
        key: config.name,
        href: `#${config.tabName}`,
        text: this.settings?.tabbarTitle || i18n.t(`modules.${config.name}.tabbarTitle`),
        'tab-link': true,
        'tab-link-active': this.defaultTab
          ? config.name === this.defaultTab
          : config.name === 'home',
      },
      on: {
        click: () => {
          bus.$emit('tabWillOpen', config.name);
        },
      },
    });
  },
  computed: {
    ...appStoreMapper.mapGetters(['defaultTab']),
    ...homeStoreMapper.mapGetters(['settings']),
  },
});
